import React from 'react';
import * as Sentry from '@sentry/browser';
import { Button } from 'react-bootstrap';

export const dsn = 'https://68072dd54262479cb53af7f8cc797177@sentry.io/5022860';
if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: dsn,
  });
}

class SentryContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error });
    Sentry.withScope(scope => {
      Object.keys(errorInfo).forEach(key => {
        scope.setExtra(key, errorInfo[key]);
      });
      Sentry.captureException(error);
    });
  }

  render() {
    if (this.state.error) {
      //render fallback UI
      return (
        <div>
          <h1>エラーが発生しました</h1>
          <p>
            <Button
              onClick={() =>
                Sentry.showReportDialog({ title: '問題が発生しています' })
              }
            >
              バグレポートを送信する
            </Button>
          </p>
        </div>
      );
    } else {
      //when there's not an error, render children untouched
      return this.props.children;
    }
  }
}

export default SentryContainer;



// WEBPACK FOOTER //
// ./src/components/Sentry.js